import { createSlice } from "@reduxjs/toolkit"
import types from "../../Actions/types"

const initialState = {
  initialized: false,
  currentVideo: { title: "", type: { name: "" } },
  currentCategoryId: -1,
  currentTypeId: -1,
  navigationItems: [],
  categories: {
    allIds: [],
    byId: {}
  },
  fetchingVideos: false,
  videos: {
    page: -1,
    perPage: -1,
    total: -1,
    allIds: [],
    lastPage: -1,
    byId: {}
  },
  fetchingCategories: false,
  types: [
    {
      videos: []
    },
    { videos: [] },
    {}
  ],
  fetchingLikeStatus: false,
  searching: false,
  transition: {
    fetching: false,
    playlists: []
  }
}

const digitalLibrarySlice = createSlice({
  name: "digitalLibrary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(types.INITIALIZED_DIGITAL_LIBRARY, (state, action) => {
      state.navigationItems = action.data.navigationItems
      state.types = action.data.types
      state.initialized = true
    })

    builder.addCase(types.CURRENT_VIDEO_LIKE_STATUS, (state, action) => {
      if (action.data.likeStatus) {
        state.likeStatus = action.data.likeStatus.like_value
        state.likeCount = action.data.likeStatus.likeCount
        state.dislikeCount = action.data.likeStatus.dislikeCount
        state.fetchingLikeStatus = false
      } else {
        state.likeStatus = 0
        state.fetchingLikeStatus = false
      }
    })

    builder.addCase(types.SHOW_SEARCH_BAR, (state) => {
      state.searching = true
    })
    builder.addCase(types.HIDE_SEARCH_BAR, (state) => {
      state.searching = false
    })

    builder.addCase(types.CURRENT_VIDEO_LIKE, (state, action) => {
      state.likeStatus = action.data.likeStatus.like_value
      state.likeCount = action.data.likeStatus.likeCount
      state.dislikeCount = action.data.likeStatus.dislikeCount
    })

    builder.addCase(types.FETCHED_CATEGORIES_VIDEOS, (state, action) => {
      state.currentCategories = action.data.categories.sort((a, b) =>
        a.name > b.name ? 1 : -1
      )
      state.videos = action.data.videos
      state.currentCategoryId = action.data.currentCategoryId
      // Keep legacy property name to avoid downstream changes
      state.currentTypeid = action.data.currentTypeId
    })

    builder.addCase(types.CURRENT_VIDEO_DISLIKE, (state, action) => {
      state.likeStatus = action.data.likeStatus.like_value
      state.likeCount = action.data.likeStatus.likeCount
      state.dislikeCount = action.data.likeStatus.dislikeCount
    })

    builder.addCase(types.CURRENT_VIDEO_LIKE_RESET, (state, action) => {
      state.likeStatus = action.data.likeStatus.like_value
      state.likeCount = action.data.likeStatus.likeCount
      state.dislikeCount = action.data.likeStatus.dislikeCount
    })

    builder.addCase(types.CLEAR_VIDEOS, (state) => {
      state.categories = { allIds: [], byId: {} }
      state.currentVideo = { title: "", type: { name: "" } }
      state.videos = { page: -1, perPage: -1, total: -1, allIds: [], byId: {} }
      state.types = { allIds: [], byId: {} }
    })

    builder.addCase(types.FETCHING_CATEGORIES, (state) => {
      state.fetchingCategories = true
    })

    builder.addCase(types.FETCHING_VIDEOS, (state) => {
      state.fetchingVideos = true
    })

    builder.addCase(types.FETCHED_VIDEOS, (state, action) => {
      state.videos = action.data.videos
      state.categories = action.data.categories
        ? action.data.categories
        : { allIds: [], byId: {} }
      state.currentCategoryId =
        action.data.currentCategoryId !== undefined
          ? action.data.currentCategoryId
          : state.currentCategoryId
      state.currentTypeId = action.data.currentTypeId
        ? action.data.currentTypeId
        : state.currentTypeId
      state.types = action.data.types ? action.data.types : state.types
      state.fetchingVideos = false
    })

    builder.addCase(types.LOAD_MORE_VIDEOS, (state, action) => {
      state.videos = action.data.videos
      state.fetchingVideos = false
    })

    builder.addCase(types.FETCHED_VIDEOS_TYPES, (state, action) => {
      state.types = action.data.types
      state.videos = action.data.videos
      state.fetchingVideos = false
    })

    builder.addCase(types.FETCHING_LIKE_STATUS, (state) => {
      state.fetchingLikeStatus = true
    })

    builder.addCase(types.FETCHED_CATEGORIES, (state, action) => {
      state.currentCategories = action.data.currentCategories
      state.fetchingCategories = false
    })

    builder.addCase(types.SET_WATCHING_VIDEOS, (state, action) => {
      state.currentVideo = action.data.currentVideo
      state.fetchingVideos = false
    })

    builder.addCase(types.STORE_TRANSITION_PLAYLIST, (state, action) => {
      state.transition = {
        ...state.transition,
        playlists: action.data.transitionPlaylists
      }
    })

    builder.addCase(types.STORE_SINGLE_PLAYLIST, (state, action) => {
      state.transition = {
        fetching: false,
        playlists: action.data.playlist
      }
    })

    builder.addCase(types.CLEAR_TRANSITIONS, (state) => {
      state.transition = {
        fetching: true,
        playlists: {}
      }
    })
  }
})

export default digitalLibrarySlice.reducer
